import React from 'react';
import  Avidreader1and82024  from 'views/Avidreader1and82024';
const DesktopAppPage = () => {
  return <Avidreader1and82024 />;
};
export default DesktopAppPage;
